// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__k0Tk3"};